// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"e6bd58cd","206":"9c6d8fc9","288":"b9689ff6","383":"55074f00","420":"49126b3e","563":"b91f88e8","963":"e45e24b5"}[chunkId] + ".chunk.css";
};